export const INVOICE_STATUSES = ['pending', 'overdue', 'paid', 'paused'] as const
export const REMINDER_TONES = ['friendly', 'firm', 'final'] as const
export const REMINDER_STATUSES = ['scheduled', 'sent', 'skipped', 'failed'] as const

export function formatCurrency(amount: number, currency: string): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount / 100)
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
